import { render, staticRenderFns } from "./vehicleModelsSelecter.vue?vue&type=template&id=58faddaa&scoped=true"
import script from "./vehicleModelsSelecter.vue?vue&type=script&lang=js"
export * from "./vehicleModelsSelecter.vue?vue&type=script&lang=js"
import style0 from "./vehicleModelsSelecter.vue?vue&type=style&index=0&id=58faddaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58faddaa",
  null
  
)

export default component.exports